export default __webpack_public_path__ + "static/food-background-a52060298ba2cf0a180fb1ee042a69d7.jpg";